import {
    StandardEditResponseModel,
    StandardResponseModel,
} from "../pages/shared/models/standard-response-model";
import { OnlineStoresModel } from "../pages/shared/models/onlineStoresModel";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getStores(
    filter?: any,
    limit?: number,
    page?: number,
): Promise<StandardResponseModel<OnlineStoresModel>> {
    try {
        const authorizationHeader = configAuthorizationHeader();

        return axiosInstance
            .get(
                `${API_URL}/online-stores?page=${page}&limit=${limit}`,
                { ...authorizationHeader },
            )
            .then((response) => {
                return response?.data as StandardResponseModel<OnlineStoresModel>;
            });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function getStoreById(postId: number, page?: number) {
    try {
        const authorizationHeader = configAuthorizationHeader();
        return axiosInstance.get(
            `${API_URL}/online-stores/${postId}?${page ? "page=" + page : ""}`,
            authorizationHeader,
        );
    } catch (error) {
        console.error(error);
    }
}

async function createStore(
    formData: FormData,
): Promise<StandardResponseModel<OnlineStoresModel>> {
    try {
        const authorizationHeader = configAuthorizationHeader();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        authorizationHeader.headers["Content-Type"] = "multipart/form-data";
        return axiosInstance
            .post(
                `${API_URL}/online-stores`,
                formData,
                authorizationHeader,
            )
            .then((response) => {
                return response?.data as StandardResponseModel<OnlineStoresModel>;
            });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function editStore(storeId: number, updateData: FormData) {
    try {
        const authorizationHeader = configAuthorizationHeader();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        authorizationHeader.headers["Content-Type"] = "multipart/form-data";
        return axiosInstance
            .put(
                `${API_URL}/online-stores/${storeId}`,
                updateData,
                authorizationHeader,
            )
            .then((response) => response?.data as StandardEditResponseModel);
    } catch (error) {
        console.error(error);

        return {
            acknowledged: false,
            matchedCount: 0,
            modifiedCount: 0,
            upsertedCount: 0,
            upsertedId: 0,
        };
    }
}

async function deleteStoreById(postId: number) {
    try {
        const authorizationHeader = configAuthorizationHeader();
        return axiosInstance.delete(
            `${API_URL}/online-stores/${postId}`,
            authorizationHeader,
        );
    } catch (error) {
        console.error(error);
    }
}

async function getStoreByCategoryId(categoryId: number): Promise<StandardResponseModel<OnlineStoresModel> | undefined> {
    try {
        const authorizationHeader = configAuthorizationHeader();
        const response = await axiosInstance.get<StandardResponseModel<OnlineStoresModel>>(
            `${API_URL}/online-stores/category/${categoryId}?limit=100`,
            authorizationHeader,
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
}

function configAuthorizationHeader() {
    let token = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");
    token = token ? token.replaceAll('"', "") : "";
    return {
        headers: {
            Authorization: "Bearer ".concat(token),
            "x-refresh-token": refreshToken,
        },
    };
}

export default {
    getStores,
    getStoreById,
    createStore,
    editStore,
    deleteStoreById,
    getStoreByCategoryId
};
